import React, { Fragment } from "react"

import classes from "./DpHeader.module.scss"

const DpHeader = props => {
  const {
    type,
    shownDate,
    selectedRange,
    selectedDate,
    setContent,
    timeRange,
    selectedTime
  } = props

  return (
    <div className={classes["header"]}>
      {type === "rangeTimePicker"
        ?
        <Fragment>
          <span className={classes["start-time"]}
          >
            شروع زمان از:{" "}
            {timeRange[0].hours}:{timeRange[0].minutes}
            <br />
            {
              !!timeRange[1] &&
              <Fragment>
                تا:{" "}
                {timeRange[1].hours}:{timeRange[1].minutes}
              </Fragment>
            }
          </span>
        </Fragment>
        :
        type === "rangeDatePicker"
          ?
          <Fragment>
            <span
              className={classes["full-year"]}
              onClick={() => setContent("years")}
            >
              {shownDate.jYear()}
            </span>
            <div className={classes["selected-range"]}>
              {!!selectedRange[1]
                ?
                selectedRange[1].format("jYYYY/jMM/jDD") : ""
              }
              {
                selectedRange.length === 2 &&
                <span>{" "}~{" "}</span>
              }
              {!!selectedRange[0] ?
                selectedRange[0].format("jYYYY/jMM/jDD") : ""
              }
            </div>
          </Fragment>
          :
          <Fragment>
            <div>
              {
                type !== "timePicker" &&
                <div
                  className={classes["full-year"]}
                  onClick={() => setContent("years")}
                >
                  {selectedDate.jYear()}
                </div>
              }
            </div>
            <div className={classes["selected-date"]}>
              {type === "dateAndTimePicker"
                ?
                selectedDate.set({
                  hours: selectedTime.hours,
                  minutes: selectedTime.minutes
                }).format("jYYYY/jMM/jDD HH:mm")
                :
                selectedDate.format("jYYYY/jMM/jDD")
              }
            </div>
          </Fragment>
      }
    </div>
  )
}

export default DpHeader